module.exports = __webpack_public_path__ + "static/media/csrd_dashboard_icon2.9438abcd.svg";